export const overflowChanger = ({
	conditionName = null,
	actionName = null,
}) => {
	const userAgent =
		typeof navigator === "undefined" ? "SSR" : navigator.userAgent;
	const isIos = () => Boolean(userAgent.match(/iPhone|iPad|iPod/i));

	if (conditionName === "ifIsHidden") {
		if (isIos()) {
			if (document.body.style.overflow === "hidden") {
				document.body.style.overflow = "unset";
			}
		} else {
			if (document.body.style.overflowY === "hidden") {
				document.body.style.overflowY = "scroll";
			}
		}
	}

	if (conditionName === "ifIsNotHidden") {
		if (isIos()) {
			if (document.body.style.overflow !== "hidden") {
				document.body.style.overflow = "hidden";
			}
		} else {
			if (document.body.style.overflowY !== "hidden") {
				document.body.style.overflowY = "hidden";
			}
		}
	}

	if (actionName === "addScroll") {
		if (isIos()) {
			document.body.style.overflow = "unset";
		} else {
			document.body.style.overflowY = "scroll";
		}
	}

	if (actionName === "addHidden") {
		if (isIos()) {
			document.body.style.overflow = "hidden";
		} else {
			document.body.style.overflowY = "hidden";
		}
	}
};
